import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, Shield, X } from 'lucide-react';
import { LanguageSelector } from './LanguageSelector';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  const navClass = (active: boolean) => `text-sm font-medium transition-colors ${active ? 'text-red-600 hover:text-red-700' : 'text-gray-600 hover:text-gray-900'}`;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 border-b border-gray-100 bg-white/80 backdrop-blur-lg transition-all">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Link to="/" className="notranslate flex items-center gap-2" translate="no">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-red-600"><Shield className="h-5 w-5 text-white" /></div>
          <span className="text-xl font-bold tracking-tight text-gray-900">futureworkhelp.net</span>
        </Link>
        <nav className="hidden items-center gap-5 md:flex" aria-label="Primary navigation">
          <Link to="/" className={navClass(isHome)}>Home</Link>
          <Link to="/faq/" className={navClass(!isHome)}>FAQ</Link>
          <LanguageSelector />
        </nav>
        <button type="button" onClick={() => setIsMenuOpen((open) => !open)} className="p-2 text-gray-600 transition-colors hover:text-red-600 md:hidden" aria-label="Toggle navigation" aria-expanded={isMenuOpen}>
          {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      <div className={`absolute top-full left-0 w-full border-b border-gray-100 bg-white transition-all duration-300 md:hidden ${isMenuOpen ? 'visible opacity-100' : 'invisible opacity-0'}`}>
        <div className="flex flex-col space-y-4 px-4 py-4 shadow-sm">
          <Link to="/" onClick={() => setIsMenuOpen(false)} className="text-sm font-bold uppercase tracking-wide text-gray-900">Home</Link>
          <Link to="/faq/" onClick={() => setIsMenuOpen(false)} className="text-sm font-bold uppercase tracking-wide text-gray-900">FAQ</Link>
          <LanguageSelector onSelect={() => setIsMenuOpen(false)} />
        </div>
      </div>
    </header>
  );
};
